module.exports = __webpack_public_path__ + "img/视频封面16.2b62cf9a.png";